import defaultMenuStyles from '../default.module.css';

import React, { forwardRef, useEffect, useState } from 'react';
import DropdownComponent from '../../../Widgets/Dropdown/DropdownComponent';
import { devicesStore } from '../../../../store/mobx/devices.store';
import PopupFormTemplate from '../../SchemeUI/PopupFormTemplate';

const DeviceModelAddMenu = forwardRef(
  (
    {
      position = {
        top: 0 | undefined,
        right: 0 | undefined,
        bottom: 0 | undefined,
        left: 0 | undefined,
      },
      onClose,
      onSubmit = undefined,
    },
    menuRef,
  ) => {
    const { deviceModels } = devicesStore;

    const [selectedDeviceModel, setSelectedDeviceModel] = useState('');

    const handleCloseClick = () => {
      if (onClose) onClose();
    };

    const handleSaveClick = () => {
      if (onSubmit) onSubmit(selectedDeviceModel);
      if (onClose) onClose();
    };

    return (
      <PopupFormTemplate
        ref={menuRef}
        position={position}
        disabled={!selectedDeviceModel}
        onSubmit={handleSaveClick}
        onClose={handleCloseClick}
      >
        <div className={defaultMenuStyles.formField}>
          <div className={defaultMenuStyles.label}>Выберите модель:</div>
          <DropdownComponent
            items={deviceModels}
            keyItem={'id'}
            valueItem={'name'}
            selectedKey={selectedDeviceModel}
            onChange={(value) => setSelectedDeviceModel(value)}
          />
        </div>
      </PopupFormTemplate>
    );
  },
);

export default DeviceModelAddMenu;
